<template>
  <v-container>
    <app-applicant-information
      :displayExamineeImage="true"
      :message="screenMessages.ResultMessage"
      :messageEx="screenMessages.TestResultsEx"
    ></app-applicant-information>

    <v-card class="mx-auto mt-10" elevation="2">
      <app-card-header
        icon="mdi-receipt"
        :text="siteText.ui.testResults"
        class="controlled-font"
      ></app-card-header>
      <v-card-text class="mx-auto">
        <v-row flex class="mx-2">
          <v-col sm="12">
            <v-simple-table dense class="pt-5">
              <thead>
                <tr>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.testType }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.numberNeededToPass }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.numberCorrect }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.numberIncorrect }}
                  </th>
                  <th class="font-weight-bold text-center controlled-font">
                    {{ siteText.ui.result }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="testAttempt in testAttempts"
                  :key="testAttempt.testAttemptId"
                >
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.testAttemptId }} -
                    {{ testAttempt.testName }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.passingScore }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{ testAttempt.totalScore }}
                  </td>
                  <td class="controlled-font pb-2 text-center">
                    {{
                      testAttempt.status == "F"
                        ? testAttempt.totalQuestionsIncorrect
                        : 0
                    }}
                  </td>
                  <td
                    class="controlled-font pb-2 text-center font-weight-bold"
                    :class="
                      testAttempt.status !== 'F'
                        ? ''
                        : resultColor(testAttempt.result)
                    "
                  >
                    {{
                      testAttempt.result === "P"
                        ? "Pass"
                        : testAttempt.status === "N"
                        ? "Not Started"
                        : "Fail"
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row flex class="mt-10">
      <v-col sm="9"></v-col>
      <v-col sm="3">
        <v-btn
          class="primary controlled-font"
          v-if="allTestsComplete"
          @click="finishTest()"
        >
          {{ this.siteText.ui.finish }}
          <v-icon right>mdi-forward</v-icon>
        </v-btn>
        <v-btn class="primary controlled-font" v-else @click="nextTest()">
          {{ siteText.ui.nextTest }}

          <v-icon right>mdi-forward</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

import appApplicantInformation from "../components/ApplicantInformation.vue";
import appCardHeader from "../components/ui/CardHeader.vue";
import * as consts from "../store/constants";

export default {
  components: {
    appApplicantInformation,
    appCardHeader,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["testAttempts", "siteText", "screenMessages"]),
    resultsMessage() {
      return "If you have completed all your assigned tests press Finish when you have reviewed the results.  If you have additional assigned tests press 'Next Test' to start the next test assigned.";
    },
    allTestsComplete() {
      return this.testAttempts.every((t) => t.status == "F");
    },
  },
  methods: {
    ...mapActions(["finished", "startTest", "setStartPage"]),
    resultColor(result) {
      return result === "P" ? "green--text" : "red--text";
    },
    finishTest() {
      //Clear session and return to start page//
      this.finished();
    },
    async nextTest() {
      const _this = this;
      const testAttempt = await this.startTest();
      if (
        testAttempt.status !== consts.TEST_STATUSES.PROGRESSING ||
        testAttempt.kioskUnAssigned
      ) {
        const message =
          testAttempt.status === consts.TEST_STATUSES.CANCELLED
            ? this.screenMessages.CancelledTest
            : !testAttempt.kioskUnAssigned
            ? this.screenMessages.SuspendedTest
            : this.screenMessages.TestUnassigned;

        this.$emit("show-alert", {
          message: message,
          callback: function() {
            _this.finished();
          },
        });
      } else {
        console.log("Starting Test");
        this.setStartPage();
      }
    },
  },
};
</script>

<style scoped>
th,
td {
  border: none !important;
  color: black !important;
}
.applicant-image {
  max-width: 125px;
}
.v-chip {
  min-width: 250px !important;
}

.v-expansion-panel-header {
  color: white;
}

.v-card__text {
  color: black !important;
}
</style>
